import React from 'react'

export default function Deco7(props) {
  return (
    <svg width={57} height={52} viewBox="0 0 57 52" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#171917" d="M29 26L1.66 30.947l18.447 19.485 26.657-3.068z" />
        <path
          d="M37.893 1.568L10.78 5.888l-9.12 25.06 18.447 19.484 26.657-3.068 9.12-25.058L37.894 1.568zm17.992 20.738L29 26 10.78 5.889m35.984 41.475L29 26 1.66 30.947"
          stroke="#171917"
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
